import classNames from 'classnames';
import React, { useCallback, useRef } from 'react';
import LazyScrollBase from '../../components/LazyScrollBase/LazyScrollBase';
import './LazyScrollContainer.scss';
import ILazyScrollContainerProps from './LazyScrollContainerProps';

const LazyScrollContainer = <T extends object>({
  offset,
  forwardRef,
  className,
  lazyScrollTrigger,
  ...rest
}: ILazyScrollContainerProps<T>) => {
  const lazyRef = useRef<HTMLElement | undefined>(lazyScrollTrigger);

  const shouldLoadMore = useCallback(() => {
    if (lazyRef.current) {
      return lazyRef.current.scrollTop + offset >= lazyRef.current.scrollHeight - lazyRef.current.offsetHeight;
    } else {
      return false;
    }
  }, []);

  const setRef = useCallback(
    (element: HTMLElement) => {
      lazyRef.current = element;
      if (forwardRef) {
        forwardRef(element);
      }
    },
    [forwardRef]
  );

  return (
    <LazyScrollBase
      className={classNames('lazy-scroll-container', className)}
      trigger={lazyScrollTrigger || 'self'}
      forwardRef={!lazyScrollTrigger ? setRef : undefined} // If passed a trigger we don't use the ref from the lazyscrollbase
      shouldLoadMore={shouldLoadMore}
      {...rest}
    />
  );
};

LazyScrollContainer.defaultProps = {
  tag: 'div',
  offset: 1000,
  sectionSize: 50,
};

export default LazyScrollContainer;
